import PROGRESS_UPDATE from './actionTypes';

const progressUpdate = progress => ({
  type: PROGRESS_UPDATE,
  progress,
});

export default progressUpdate;



// WEBPACK FOOTER //
// ./src/actions/progress/index.js